export default __webpack_public_path__ + "static/media/Hippydick.54358d8f.PNG";